"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventType = void 0;
var EventType;
(function (EventType) {
    EventType[EventType["None"] = 0] = "None";
    EventType[EventType["TurnStarted"] = 2] = "TurnStarted";
    EventType[EventType["TurnEnded"] = 3] = "TurnEnded";
    EventType[EventType["Tick"] = 4] = "Tick";
    EventType[EventType["ActorDisabled"] = 5] = "ActorDisabled";
    EventType[EventType["ActorEnabled"] = 6] = "ActorEnabled";
    EventType[EventType["Attack"] = 100] = "Attack";
    EventType[EventType["Damaged"] = 101] = "Damaged";
    EventType[EventType["Healed"] = 102] = "Healed";
    EventType[EventType["Killed"] = 103] = "Killed";
    EventType[EventType["Resurrected"] = 104] = "Resurrected";
    EventType[EventType["AbilityUsed"] = 105] = "AbilityUsed";
    EventType[EventType["DamageAbsorbed"] = 106] = "DamageAbsorbed";
    EventType[EventType["DeathAvoided"] = 107] = "DeathAvoided";
    EventType[EventType["Attacked"] = 108] = "Attacked";
    EventType[EventType["DamageDealt"] = 109] = "DamageDealt";
    EventType[EventType["RoomEntered"] = 300] = "RoomEntered";
    EventType[EventType["RoomExited"] = 301] = "RoomExited";
    EventType[EventType["RoomAdded"] = 302] = "RoomAdded";
    EventType[EventType["RoomFailed"] = 303] = "RoomFailed";
    EventType[EventType["RoomCleared"] = 304] = "RoomCleared";
    EventType[EventType["AdventureFailed"] = 305] = "AdventureFailed";
    EventType[EventType["AdventureCompleted"] = 306] = "AdventureCompleted";
    EventType[EventType["AdventureStarted"] = 307] = "AdventureStarted";
    EventType[EventType["ActorKilled"] = 399] = "ActorKilled";
    EventType[EventType["AllyKilled"] = 400] = "AllyKilled";
    EventType[EventType["EnemyKilled"] = 401] = "EnemyKilled";
    EventType[EventType["AllyResurrected"] = 402] = "AllyResurrected";
    EventType[EventType["EnemyResurrected"] = 403] = "EnemyResurrected";
    EventType[EventType["ActorAdded"] = 500] = "ActorAdded";
    EventType[EventType["CompanionAdded"] = 501] = "CompanionAdded";
    EventType[EventType["AttributeChanged"] = 600] = "AttributeChanged";
    EventType[EventType["TurnMeterChanged"] = 601] = "TurnMeterChanged";
    EventType[EventType["MaxAttributeChanged"] = 602] = "MaxAttributeChanged";
    EventType[EventType["FactionChanged"] = 603] = "FactionChanged";
    EventType[EventType["EffectApplied"] = 700] = "EffectApplied";
    EventType[EventType["EffectCancelled"] = 701] = "EffectCancelled";
    EventType[EventType["EventHandlerRegistered"] = 702] = "EventHandlerRegistered";
    EventType[EventType["EventHandlerCancelled"] = 703] = "EventHandlerCancelled";
    EventType[EventType["EventHandlerStarted"] = 704] = "EventHandlerStarted";
    EventType[EventType["EventHandlerEnded"] = 705] = "EventHandlerEnded";
    EventType[EventType["AbilityDisabled"] = 706] = "AbilityDisabled";
    EventType[EventType["AbilityEnabled"] = 707] = "AbilityEnabled";
    EventType[EventType["AdventureMetaUpdated"] = 708] = "AdventureMetaUpdated";
})(EventType = exports.EventType || (exports.EventType = {}));
